export function Badge({ text }: { text: string }) {
  return (
    <span className="ml-2 mr-2 flex-shrink-0 whitespace-nowrap rounded-full border border-brand-subtle bg-brand-tertiary px-1.5 py-[1px] text-xxs text-brand-primary">
      {text}
    </span>
  );
}
